exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-wrapper-scroll-y[data-v-b3d938b0] {\r\n  display: block;\r\n  overflow-y: auto;\r\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\r\n", ""]);

// exports
